export default __webpack_public_path__ + "static/media/roboto-latin-ext-400-normal.c3dcdbd5.woff2";